function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg192Turkmenistan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#496E2D"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M407.816,147.517c12.596-35.108-1.555-73.288-31.922-92.305c5.462,0.711,10.93,1.997,16.327,3.932   c40.505,14.532,61.558,59.145,47.026,99.649c-14.532,40.505-59.145,61.558-99.649,47.026c-5.397-1.936-10.436-4.421-15.104-7.344   C360.024,203.1,395.221,182.624,407.816,147.517z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "337.957,45.589 327.012,59.73 310.182,53.692 320.249,68.47 309.306,82.61 326.471,77.604    336.539,92.38 337.08,74.508 354.245,69.501 337.416,63.464  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "367.509,91.668 356.565,105.809 339.734,99.77 349.802,114.549 338.857,128.689    356.024,123.681 366.091,138.46 366.632,120.587 383.799,115.58 366.967,109.541  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "285.852,62.371 274.907,76.511 258.077,70.473 268.144,85.251 257.2,99.391 274.365,94.385    284.434,109.163 284.975,91.29 302.14,86.283 285.311,80.244  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "284.652,115.154 273.707,129.296 256.877,123.257 266.945,138.035 256,152.175    273.166,147.169 283.234,161.947 283.775,144.073 300.941,139.067 284.11,133.028  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "334.879,133.175 323.935,147.316 307.104,141.277 317.172,156.055 306.227,170.195    323.394,165.189 333.461,179.967 334.002,162.093 351.169,157.086 334.337,151.048  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.74,
    style: {
      fill: "#D80027"
    },
    width: 133.565,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "92.712,134.783 70.35,118.125 70.35,94.569 92.712,77.911 124.337,77.911 146.699,94.569   146.699,118.125 124.337,134.783 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "108.524,77.911 92.712,77.911 70.35,94.569 70.35,106.085 108.524,106.085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "108.524,134.783 124.337,134.783 146.699,118.125 146.699,106.109 108.524,106.109  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "92.712,434.091 70.35,417.434 70.35,393.876 92.712,377.218 124.337,377.218   146.699,393.876 146.699,417.434 124.337,434.091 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "108.524,377.218 92.712,377.218 70.35,393.876 70.35,405.393 108.524,405.393  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "108.524,434.091 124.337,434.091 146.699,417.434 146.699,405.416 108.524,405.416  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "92.712,284.437 70.35,267.779 70.35,244.223 92.712,227.564 124.337,227.564    146.699,244.223 146.699,267.779 124.337,284.437  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "147.482,321.087 137.742,321.087 137.742,311.348 120.626,311.348 108.523,299.246    96.422,311.348 79.307,311.348 79.307,321.087 69.567,321.087 69.567,340.567 79.307,340.567 79.307,350.306 96.421,350.306    108.524,362.409 120.626,350.306 137.742,350.306 137.742,340.567 147.482,340.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "147.482,171.434 137.742,171.434 137.742,161.695 120.626,161.695 108.523,149.592    96.422,161.695 79.307,161.695 79.307,171.434 69.567,171.434 69.567,190.913 79.307,190.913 79.307,200.652 96.421,200.652    108.524,212.755 120.626,200.652 137.742,200.652 137.742,190.913 147.482,190.913  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.391,
    y: 244.87,
    style: {
      fill: "#D80027"
    },
    width: 22.261,
    height: 22.261
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 108.522,
    cy: 181.17,
    r: 11.13
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 108.522,
    cy: 330.83,
    r: 11.13
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg192Turkmenistan);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };